import { styled } from '@mui/material/styles'
import Link from 'next/link'

export const StyledLink = styled(Link)({
  textDecoration: 'none',
  color: 'inherit',
})
